// extracted by mini-css-extract-plugin
export default {"root":"_GFjpEqlfM","image":"hK_pJwS3BG","image_svg":"RoTxqFib1h"};